module.exports = __webpack_public_path__ + "img/bulb-orange.89049d18.png";